import { Box, Tag, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import UserAvatar from 'modules/core/components/UserAvatar'
import i18n from 'modules/core/lib/i18n'

import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import { shiftConflictIsDate } from 'modules/shift_management/lib/shiftConflictIsDate'
import type Leave from 'modules/shift_management/store/internal/models/Leave'

interface Props {
  date: moment.Moment
  leave: Leave
}

const LeaveItem = ({ date, leave }: Props) => {
  const [{ shiftsConflicts }] = useSchedule()

  const hasConflictWithLeave = (date: moment.Moment, leave: Leave): boolean => {
    return shiftsConflicts.shift_conflicts.some(
      (sc) => shiftConflictIsDate(sc, date) && sc.hasConflictWithLeave(leave)
    )
  }

  const hasConflict = hasConflictWithLeave(date, leave)

  const userData = {
    avatar: leave.employeeAvatar,
    fullName: leave.employeeFullName,
  }

  return (
    <Box key={leave.id} gap="s12" flexDirection="column" alignItems="flexStart">
      <Box flexDirection="row" alignItems="center" gap="s12">
        <UserAvatar size="s24" user={userData} />
        <Text.Normal>{leave.employeeFullName}</Text.Normal>
      </Box>
      {hasConflict && (
        <Tag type="radical">{i18n.t('shift_management.sidepanel.shift_conflict')}</Tag>
      )}
    </Box>
  )
}

export default observer(LeaveItem)
